import React from 'react';
import Routes from './components/Routes';
import './App.css';

const App = () => {
  return (
    <div className="App">
      <Routes/>
    </div>
  );
}

export default App;
